
const getEnumTranslation = ({ localize, enumName, value = 0 }) =>
  (typeof value === 'number' || typeof value === 'string')
    ? localize(`Enums.${enumName}_${value}`)
    : ''
const values = (type) => Object.keys(type).map(x => type[x]) // Object.values(type) not supported by IE

const getEnumKey = (enumType, value) => Object.keys(enumType).find(x => enumType[x] === value)

export { values, getEnumKey }
export default getEnumTranslation



// WEBPACK FOOTER //
// ./src/enums/enums.js